/** @jsx _j **/
/** @jsxFrag _f **/

const { jsx: _j, F: _f } = require('astroturf');
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import React from 'react';
import BaseFormLabel from 'react-bootstrap/FormLabel';
import Text from './Text';
const FormLabel = React.forwardRef((props, ref) => {
  return _j(Text, _extends({
    ref: ref
  }, props, {
    as: BaseFormLabel,
    color: "headline",
    css: [require("./FormLabel-CssProp1_Text.module.scss"), []]
  }));
});
FormLabel.displayName = 'FormLabel';
export default FormLabel;